<script>
import moment from 'moment'
import appConfig from '@src/app.config'
import { crudMethods } from '@state/helpers'

export default {
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },

  components: {},

  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},

      data: [],
      dataResult: [],

      rows: 1,
      perPage: 1,
      currentPage: 1,
      total: 1,
      from: 1,
      to: 1,

      modalTable: false,

      rStatus: '',
      rProgress: '',
      rBa: '',
      rBaSirkulir: '',
      rSitewitel: '',
      rTahun: '',

      fields: [],

      dataPie: {
        chartOptions: {
          chart: {
            type: 'pie',
            toolbar: {
              show: false,
            },
            fontFamily: 'inherit',
          },

          colors: [
            '#dc2626',
            '#f97316',
            '#eab308',
            '#0ea5e9',
            '#14b8a6',
            '#8b5cf6',
          ],

          stroke: {
            width: 2,
            colors: ['#ffffff'],
          },

          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '11px',
            labels: {
              colors: '#64748b',
            },
            itemMargin: {
              horizontal: 8,
              vertical: 3,
            },
            markers: {
              width: 8,
              height: 8,
              radius: 8,
            },
          },

          labels: [],

          dataLabels: {
            enabled: true,
            style: {
              fontSize: '11px',
              fontWeight: 600,
            },
            dropShadow: {
              enabled: false,
            },
          },

          plotOptions: {
            pie: {
              expandOnClick: true,
              customScale: 0.9,
            },
          },

          responsive: [
            {
              breakpoint: 768,
              options: {
                chart: {
                  height: 270,
                },
                legend: {
                  position: 'bottom',
                  horizontalAlign: 'center',
                },
              },
            },
          ],

          tooltip: {
            y: {
              formatter: (value) => {
                return this.formatCompactCurrency(value)
              },
            },
          },
        },

        series: [],
      },

      year: moment().format('YYYY'),
      years: [],
    }
  },

  mounted() {
    this.getData()
    this.getListData()

    for (let i = this.year; i >= 2022; i--) {
      this.years.push(i)
    }
  },

  methods: {
    ...crudMethods,

    getData() {
      this.listData({
        url: `web/dashboard/pie-revenue-segment?year=${this.year}`,
      }).then((response) => {
        const { data } = response.data

        this.setPieChartData(data)
      })
    },

    getListData() {
      this.listData({
        url: `web/dashboard/revenue-segment?year=${this.year}`,
      }).then((response) => {
        this.data = response.data.data || []
      })
    },

    setPieChartData(data) {
      this.dataPie = {
        series: data.series || [],

        chartOptions: {
          ...this.dataPie.chartOptions,

          labels: data.labels || [],
        },
      }
    },

    changeYear() {
      this.getData()
      this.getListData()
    },

    formatCompactCurrency(value) {
      const number = Math.abs(Number(value || 0))

      if (number >= 1.0e9) {
        return `Rp${(number / 1.0e9).toFixed(2)} M`
      }

      if (number >= 1.0e6) {
        return `Rp${(number / 1.0e6).toFixed(2)} Jt`
      }

      if (number >= 1.0e3) {
        return `Rp${(number / 1.0e3).toFixed(2)} Rb`
      }

      return `Rp${number.toLocaleString('id-ID')}`
    },

    formatCurrency(value) {
      return `Rp${Number(value || 0)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },

    getTotal(field) {
      return this.data.reduce(
        (total, item) => total + Number(item[field] || 0),
        0
      )
    },

    getFeeTotal() {
      return this.data.reduce(
        (total, item) =>
          total + (Number(item.spk || 0) - Number(item.sph || 0)),
        0
      )
    },
  },
}
</script>

<template>
  <div class="revenue-segment-widget">
    <div class="card dashboard-card">
      <!-- HEADER -->
      <div class="card-header dashboard-card-header">
        <div class="header-title-wrapper">
          <div class="header-icon">
            <feather type="pie-chart" size="17" />
          </div>

          <div>
            <h5 class="header-title">
              Revenue Per Segment
            </h5>

            <div class="header-subtitle">
              Distribusi nilai kontrak berdasarkan segment
            </div>
          </div>
        </div>

        <div class="header-action">
          <label for="revenue-segment-year">
            Tahun
          </label>

          <b-form-select
            id="revenue-segment-year"
            v-model="year"
            :options="years"
            size="sm"
            @change="changeYear"
          />
        </div>
      </div>

      <!-- BODY -->
      <div class="card-body dashboard-card-body">
        <div class="dashboard-content">
          <!-- CHART -->
          <div class="chart-column">
            <div v-if="dataPie.series.length > 0" class="chart-wrapper">
              <apexchart
                height="350"
                :series="dataPie.series"
                :options="dataPie.chartOptions"
              />
            </div>

            <div v-else class="empty-chart">
              <feather type="pie-chart" size="28" />

              <span>
                Tidak ada data
              </span>
            </div>
          </div>

          <!-- TABLE -->
          <div class="table-column">
            <div class="table-wrapper">
              <table class="table table-dashboard">
                <thead>
                  <tr>
                    <th class="text-left">
                      Segment
                    </th>

                    <th class="text-right">
                      Nilai Kontrak
                    </th>

                    <th class="text-right">
                      Nilai Kewajiban
                    </th>

                    <th class="text-right">
                      Fee Kopeg
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in data" :key="index">
                    <td>
                      <div class="segment-name">
                        <span class="segment-dot"></span>

                        {{ item.segment }}
                      </div>
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(item.spk) }}
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(item.sph) }}
                    </td>

                    <td class="text-right fee-value">
                      {{
                        formatCurrency(
                          Number(item.spk || 0) - Number(item.sph || 0)
                        )
                      }}
                    </td>
                  </tr>

                  <!-- GRAND TOTAL -->
                  <tr class="grand-total">
                    <td>
                      Grand Total
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(getTotal('spk')) }}
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(getTotal('sph')) }}
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(getFeeTotal()) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.revenue-segment-widget {
  margin-top: 1.5rem;
  width: 100%;
}

/* =========================================================
   CARD
========================================================= */

.dashboard-card {
  margin-bottom: 20px;
  overflow: hidden;

  border: 1px solid #edf0f3;
  border-radius: 12px;

  background: #ffffff;

  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03),
    0 8px 24px rgba(15, 23, 42, 0.04);
}

/* =========================================================
   HEADER
========================================================= */

.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 64px;

  padding: 13px 18px;

  border-bottom: 1px solid #f1f5f9;

  background: #ffffff;
}

.header-title-wrapper {
  display: flex;
  align-items: center;

  min-width: 0;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  margin-right: 11px;

  border-radius: 9px;

  color: #dc2626;
  background: #fef2f2;
}

.header-title {
  margin: 0;

  color: #1e293b;

  font-size: 14px;
  font-weight: 700;

  line-height: 1.3;
}

.header-subtitle {
  margin-top: 2px;

  color: #94a3b8;

  font-size: 10px;

  line-height: 1.3;
}

/* =========================================================
   YEAR SELECT
========================================================= */

.header-action {
  display: flex;
  align-items: center;

  gap: 7px;

  flex-shrink: 0;

  label {
    margin: 0;

    color: #64748b;

    font-size: 11px;
    font-weight: 600;
  }

  .custom-select {
    width: 90px;
    min-height: 32px;

    padding-top: 4px;
    padding-bottom: 4px;

    border-color: #e2e8f0;
    border-radius: 7px;

    color: #475569;

    font-size: 11px;

    box-shadow: none;

    &:focus {
      border-color: #dc2626;

      box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.08);
    }
  }
}

/* =========================================================
   BODY
========================================================= */

.dashboard-card-body {
  padding: 14px 18px 16px;
}

.dashboard-content {
  display: grid;

  grid-template-columns:
    minmax(350px, 40%)
    minmax(0, 60%);

  align-items: center;

  gap: 10px;
}

/* =========================================================
   CHART
========================================================= */

.chart-column {
  display: flex;

  align-items: center;
  justify-content: center;

  min-width: 0;
}

.chart-wrapper {
  width: 100%;

  max-width: 420px;

  min-width: 0;
}

.empty-chart {
  display: flex;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  width: 100%;
  height: 350px;

  color: #cbd5e1;

  font-size: 11px;

  svg {
    margin-bottom: 8px;
  }
}

/* =========================================================
   TABLE
========================================================= */

.table-column {
  min-width: 0;
}

.table-wrapper {
  width: 100%;

  /*
   * Segment biasanya tidak sebanyak Witel.
   * Tetapi kalau data bertambah, table tetap
   * tidak membuat dashboard terlalu panjang.
   */
  max-height: 350px;

  overflow-x: auto;
  overflow-y: auto;

  border: 1px solid #e2e8f0;
  border-radius: 9px;
}

/* =========================================================
   TABLE STYLE
========================================================= */

.table-dashboard {
  width: 100%;

  min-width: 620px;

  margin: 0;

  color: #475569;

  font-size: 11px;

  border-collapse: separate;
  border-spacing: 0;

  thead {
    th {
      position: sticky;
      top: 0;
      z-index: 2;

      padding: 10px 10px;

      border: 0;
      border-bottom: 1px solid #e2e8f0;

      background: #f8fafc;

      color: #64748b;

      font-size: 10px;
      font-weight: 700;

      white-space: nowrap;
    }
  }

  tbody {
    td {
      padding: 9px 10px;

      border: 0;
      border-bottom: 1px solid #f1f5f9;

      vertical-align: middle;

      white-space: nowrap;
    }

    tr {
      transition: background 0.15s ease;

      &:hover:not(.grand-total) {
        background: #fafafa;
      }

      &:last-child td {
        border-bottom: 0;
      }
    }
  }
}

/* =========================================================
   SEGMENT
========================================================= */

.segment-name {
  display: flex;
  align-items: center;

  color: #334155;

  font-weight: 600;
}

.segment-dot {
  width: 6px;
  height: 6px;

  margin-right: 7px;

  flex-shrink: 0;

  border-radius: 50%;

  background: #dc2626;
}

/* =========================================================
   FEE
========================================================= */

.fee-value {
  color: #dc2626;

  font-weight: 600;
}

/* =========================================================
   GRAND TOTAL
========================================================= */

.grand-total {
  td {
    position: sticky;
    bottom: 0;
    z-index: 1;

    border-top: 2px solid #e2e8f0 !important;

    background: #ffffff;

    color: #1e293b;

    font-weight: 700;
  }

  td:last-child {
    color: #b91c1c;
  }
}

/* =========================================================
   SCROLLBAR
========================================================= */

.table-wrapper::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f8fafc;
}

.table-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;

  background: #cbd5e1;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* =========================================================
   RESPONSIVE
========================================================= */

@media (max-width: 1199.98px) {
  .dashboard-content {
    grid-template-columns:
      minmax(300px, 38%)
      minmax(0, 62%);
  }
}

@media (max-width: 991.98px) {
  .dashboard-content {
    grid-template-columns: 1fr;

    gap: 16px;
  }

  .chart-wrapper {
    max-width: 430px;
  }

  .table-wrapper {
    max-height: 360px;
  }
}

@media (max-width: 575.98px) {
  .dashboard-card-header {
    align-items: flex-start;

    flex-direction: column;

    gap: 10px;
  }

  .header-action {
    width: 100%;

    justify-content: flex-end;
  }

  .dashboard-card-body {
    padding: 10px 12px 14px;
  }

  .dashboard-content {
    gap: 12px;
  }

  .chart-wrapper {
    max-width: 100%;
  }

  .table-dashboard {
    font-size: 10px;
  }

  .table-dashboard thead th,
  .table-dashboard tbody td {
    padding: 8px;
  }
}
</style>
